import React from 'react'
import Image from '../../../images/buyerpolicies/Product.png'

const Product = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Product</h2>
            <p>We at KAAY have the right to alter the price, delivery charges, and item details for any products. We can add or remove charges, and product specifications whenever we want. We make sure to present the pictures and images of the products listed on the website as close to the real stuff as possible. </p>
            <p>KAAY has the right over all the pictures or glitches in the picture and cannot actually ensure that all the images are exactly like the products. Sometimes, the size, shape, and colors of the image alter as per the device/phone/laptop you have been using. Do not take it as the exact sample of what you receive.</p>
        </div>
      </div>
    </div>
  )
}

export default Product
